import React from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import SideMenu from 'Components/SideMenu/SideMenu';
import { useSidebar } from 'Providers/SidebarProvider';
import cx from 'classnames';
import classes from './AppLayout.module.scss';
import { FormattedMessage } from 'react-intl';

interface IAppLayoutProps {
  children?: React.ReactNode;
  hideSideMenu?: boolean;
}

const AppLayout: React.FC<IAppLayoutProps> = ({ children, hideSideMenu }) => {
  // Mobile menu state
  const { isMobile, mobileOpen, drawerOpen, handleDrawerToggle, showToolbar } =
    useSidebar();

  // Determine content class based on sidebar state
  const getContentClass = () => {
    let baseClass =
      showToolbar && !hideSideMenu
        ? classes.contentWithToolbar
        : classes.content;

    // Add sidebar collapsed class for desktop when drawer is collapsed
    if (!isMobile && !hideSideMenu && !drawerOpen) {
      baseClass = cx(baseClass, classes.sidebarCollapsed);
    }

    return baseClass;
  };

  return (
    <div className={classes.root}>
      {!hideSideMenu && (
        <div className={classes.sideMenuContainer}>
          <SideMenu
            mobileOpen={mobileOpen}
            drawerOpen={drawerOpen}
            onMobileMenuToggle={handleDrawerToggle}
            onDrawerToggle={handleDrawerToggle}
          />
        </div>
      )}

      {/** Toolbar - shows on mobile or when drawer is collapsed */}
      {showToolbar && !hideSideMenu && (
        <div className={classes.toolbar}>
          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              color: 'white',
            }}
          >
            <MenuIcon />
          </IconButton>
          <h3 className={classes.toolbarTitle}>
            <FormattedMessage id="liftstatus" />
          </h3>
        </div>
      )}

      <div className={getContentClass()}>{children}</div>
    </div>
  );
};

export default AppLayout;
